import { Component, inject } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { BlockUIModule } from 'primeng/blockui';
import { NavigationPreferencesService } from '@services/navigation-preferences.service';

@Component({
	selector: 'd-toast',
	imports: [ToastModule, ProgressBarModule, BlockUIModule],
	templateUrl: './d-toast.html',
})
export class DToast {
	private readonly navigationPreferences = inject(NavigationPreferencesService);
	readonly position = this.navigationPreferences.toastPosition;
}
